export default __webpack_public_path__ + "static/media/AWS2020.44d93740.png";